export default `
City,Person
7/31/2026,Councilmember Sheila Mohan
Agoura Hills,Councilmember Penny Sylvester
Agoura Hills,Councilmember Linda Northrup **
Agoura Hills,Councilmember Denis Weber **
Alameda,Councilmember Tracy Jenson
Alameda,Vice Mayer Michele Pryor
Alameda,Councilmember Trish Herrera Spencer **
Alturas,Mayor Paul Minchella
Anaheim,Councilmember Ryan Balius
Anaheim,Mayor Pro Tem Natalie Meeks
Anaheim,Councilmember Trevor O'Neil **
Anderson,Councilmember Susie Baugh *
Anderson,Councilmember Mike Gallagher *
Anderson,Mayor Baron Browning **
Anderson,Councilmember Melissa Hunt **
Anderson,Councilmember Stan Neutze **
Angels Camp,Councilmember Gretel Tiscornia **
Antioch,Mayor Pro-Tem Joy Motts **
Arcadia,Mayor Paul P Cheng *
Arcadia,Councilmember Michael Danielson **
Arcadia,Councilmember Sho Tay **
Arcadia,Councilmember Tom Beck **
Arcadia,Mayor Pro Tem April Verlato **
Artesia,Councilmember Tony Lima **
Atherton,Councilmember Elizabeth Lewis *
Atherton,Vice Mayor Rick DeGolia *
Atherton,Councilmember Bill Widmer
Atherton,Councilmember Cary Wiest **
Atherton,Vice Mayor Michael Lempres **
Auburn,Vice Mayor Kelley Davis *
Auburn,Mayor Sandy Amara *
Auburn,Councilmember Rachel Radell-Harris
Auburn,Councilmember Mike Holmes
Auburn,Councilmember Rachel Radell-Harris **
Auburn,Councilmember Michelle Sierra Sammons **
Avalon,Councilmember Mary Schickling **
Avenal,Councilmember Ricardo Verdugo
Azusa,Councilmember Robert Gonzales
Azusa,Councilmember Andrew Mendez
Azusa,Mayor Edward Alvarez
Azusa,Mayor Pro Tem Uriel Macias **
Azusa,Councilmember Dennis Beckwith **
Banning,Councilmember Sheri Flynn
Banning,Mayor Richard Royce
Banning,Councilmember Colleen Wallace
Barstow,Councilmember Carmen Hernandez
Beaumont,Councilmember Mike Lara
Beaumont,Councilmember Rey Santos **
Bell,Councilmember  Ali Saleh
Bellflower,Councilmember Daniel Koops *
Bellflower,Councilmember Ray Dunton *
Bellflower,Mayor Sonny Santa Ines *
Bellflower,Councilmember Raymond Y Hamada **
Bellflower,Mayor Juan Garza **
Beverly Hills,Mayor Craig A. Corman
Beverly Hills,Vice Mayor Mary Wells
Beverly Hills,Councilmember Sharona Nazarian
Beverly Hills,Councilmember Lester Friedman
Beverly Hills,Vice Mayor Bob Wunderlich **
Beverly Hills,Councilmember Lili Bosse **
Beverly Hills,Councilmember Julian Gold **
Beverly Hills,Councilmember John Mirisch **
Big Bear Lake,Mayor Randall Putz *
Big Bear Lake,Mayor Pro Tem Kendi Segovia
Big Bear Lake,Councilmember Rick Herrick
Big Bear Lake,Councilmember Bill Jahn **
Big Bear Lake,Councilmember Bob Jackowski **
Big Bear Lake,Councilmember David Caretto **
Big Bear Lake,Councilmember Bynette Mote **
Blue Lake,Councilmember Olivia Obidah-Dunn **
Bradbury,Councilmember Bruce Lathrop *
Bradbury,Councilmember Richard Hale *
Bradbury,Mayor Elizabeth Bruny *
Bradbury,Councilmember Richard Barakat *
Bradbury,Councilmember D. Montgomery Lewis **
Brawley,Mayor Sam Couchman **
Brawley,Mayor Pro Tem Donald Wharton **
Brawley,Councilmember George A Nava **
Brawley,Councilmember Luke Hamby **
Brawley,Mayor Norma Kastner-Jauregui **
Brea,Mayor Cecilia Hupp
Brea,Councilmember Blair Stewart
Brea,Councilmember Steven Vargas
Brentwood,Councilmember Faye Maloney
Brentwood,Mayor Susannah Meyer
Brentwood,Councilmember Johnny Rodriguez **
Brentwood,Councilmember Karen Rarey **
Brentwood,Councilmember Jovita Mendoza **
Brentwood,Mayor Joel Bryant **
Buellton,Councilmember John Sanchez *
Buellton,Councilmember Hudson Hornick
Buellton,Councilmember Ed Andrisek **
Buellton,Vice Mayor Art Mercado **
Buellton, Holly Sierra **
Buellton,Mayor David King **
Buena Park,Councilmember Art Brown **
Burbank,Councilmember Timothy M. Murphy **
Burbank,Councilmember Sharon Springer **
Burlingame,Councilmember Donna Colson
Burlingame,Councilmember Ann O'Brien Keighran **
Calabasas,Councilmember Alicia Weintraub
Calabasas,Mayor James Bozajian
Calabasas,Mayor ProTem Ed Albrecht
Calexico,Mayor Pro Tem Lorenzo Calderon
California City,Mayor Marquette Hawkins
California City,Councilmember Jim Creighton **
Calistoga,Vice Mayor Lisa Gift
Calistoga,Mayor Donald Williams
Canyon Lake,Councilmember Josh Steeber *
Canyon Lake,Mayor Mark Terry *
Canyon Lake,Councilmember Jeremy Smith *
Canyon Lake,Mayor Pro Tem Kasey Castillo *
Canyon Lake,Councilmember Jennifer Dain **
Capitola,Vice Mayor Gerry Jenson *
Capitola,Councilmember Susan Westman
Carlsbad,Councilmember Kevin Shin
Carlsbad,Councilmember Melanie Burkholder
Carmel-by-the-Sea,Mayor Dale Byrne
Carmel-by-the-Sea,Councilmember Alissandra Dramov
Carmel-by-the-Sea,Mayor Dave Potter **
Carmel-by-the-Sea,Mayor Pro Tem Bobby Richards **
Carpinteria,Councilmember Al Clark
Carson,Mayor Lula Davis-Holmes
Carson,Councilmember  Cedric Hicks
Cathedral City,Mayor Pro Tem Ernesto Gutierrez
Ceres,Councilmember James Casey
Ceres,Vice Mayor Bret Silveira **
Cerritos,Councilmember Lynda P. Johnson
Cerritos,Councilmember Frank Aurelio Yokoyama
Chino,Mayor Pro Tem Curtis Burton
Claremont,Councilmember Corey Calaycay
Clayton,Mayor Jeff Wan
Cloverdale,Vice Mayor Todd Lands
Clovis,Mayor Vong Mouanoutoua
Clovis,Mayor Pro Tem Diane Pearce
Coalinga,Councilmember Jeremy Lowder
Coalinga,Mayor Ron Lander **
Coalinga,Councilmember Tanya Stolz **
Coalinga,Councilmember Ray Singleton **
Coalinga,Councilmember Ron Ramsey **
Coalinga,Councilmember Adam Adkisson **
Colfax,Councilmember Trinity Burruss *
Colfax,Councilmember Sean Lomen
Colfax,Councilmember Joe Fatula **
Colfax,Councilmember David Ackerman **
Colfax,Mayor Pro Tem Marnie Mendoza **
Colma,Mayor Carrie Slaughter
Colton,Councilmember John Echevarria *
Colton,Councilmember David Toro *
Colton,Councilmember Luis Gonzalez *
Colton,Councilmember Kelly J. Chastain
Colton,Mayor Frank Navarro
Colton,Councilmember Isaac Suchil **
Colton,Councilmember Ernest Cisneros **
Compton,Mayor Emma Sharif
Compton,Councilmember Andre Spicer
Compton,Councilmember Deidre Duhart
Compton,Councilmember Jonathan Bowers
Compton,Councilmember Tana McCoy **
Corona,Mayor   Jacque Casillas *
Corona,Councilmember Jim Steiner *
Corona,Vice Mayor Wes Speake
Corona,Councilmember - District 4 Yolanda Carrillo **
Corona,Councilmember - District 3 Jason Scott **
Coronado,Councilmember  Kelly Purvis
Coronado,Councilmember Amy Steward
Coronado,Mayor   John Duncan
Coronado,Councilmember Bill Sandke **
Coronado,Councilmember Marvin Heinze **
Coronado,Mayor Pro Tem Casey Tanaka **
Coronado,Councilmember Mike Donovan **
Coronado,Mayor Richard Bailey **
Corte Madera,Councilmember Pat Ravasio
Corte Madera,Councilmember Bob Ravasio **
Costa Mesa,Councilmember  Don Harper **
Covina,Councilmember Victor Linares *
Covina,Mayor Pro Tem Patricia Cortez *
Covina,Councilmember Walter Allen
Covina,Mayor Jorge Marquez **
Covina,Councilmember John King **
Crescent City,Councilmember Ray Altman
Cupertino, Darcy Paul **
Cupertino,Councilmember Jon Robert Willey **
Cypress,Mayor Leo Medrano
Dana Point,Mayor Pro Tem Mike Frost
Dana Point,Councilmember Jamey Federico
Dana Point,Councilmember Matthew Pagano
Dana Point,Councilmember Joseph  Muller **
Danville,Councilmember Mark Belotz
Danville,Mayor Newell Arnerich
Danville,Councilmember Karen Stepper
Del Mar,Deputy Mayor Tracy Martinez
Del Mar,Mayor Terry Gaasterland
Desert Hot Springs,Councilmember Daniel Pitts
Desert Hot Springs,Mayor Pro Tem Dirk Voss
Desert Hot Springs,Councilmember Russell Betts **
Dixon,Mayor Steve Bird
Downey,Mayor Pro Tem Horacio Ortiz
Downey,Councilmember Dorothy Pemberton
Downey,Mayor Claudia Frometa
Dublin,Councilmember Arun Goel **
Eastvale,Mayor Pro Tem Clint Lorimore
El Cajon,Councilmember Gary Kendrick *
El Cajon,Deputy Mayor Michelle Metschel *
El Cajon,Councilmember Phil Ortiz *
El Cajon,Mayor Bill Wells
El Cajon,Councilmember Steve Goble
El Monte,Mayor Jessica Ancona
El Monte,Councilmember Richard Rojo **
El Segundo,Councilmember Drew Boyles *
El Segundo,Mayor Chris Pimentel *
El Segundo,Councilmember Lance Giroux
El Segundo,Councilmember Carol Pirsztuk **
El Segundo,Councilmember Scot Nichol **
Emeryville,Councilmember Kalimah A Priforce
Encinitas,Mayor Bruce Ehlers
Encinitas,Councilmember Luke Shaffer
Encinitas,Deputy Mayor Jim O'hara
Encinitas,Councilmember Marco San Antonio
Escalon,Mayor Andrew Hagan
Escalon,Councilmember Shawn Strohman
Escalon,Councilmember Jeff Laugero **
Escalon,Mayor David Bellinger **
Escalon,Councilmember Ed Alves **
Escalon,Councilmember Peter Krumeich **
Escalon,Councilmember Robert Swift **
Escondido,Councilmember Michael Morasco **
Fillmore,Councilmember Carrie Broggie
Fillmore,Councilmember Mark Austin **
Firebaugh,Councilmember Elsa Lopez
Firebaugh,Councilmember Felipe Perez
Folsom,Mayor Justin Raithel *
Folsom,Mayor Pro Tem Anna Rohrbough *
Folsom,Councilmember Sarah Aquino *
Folsom,Councilmember Barbara Leary
Folsom,Councilmember Kerri Howell **
Folsom,Councilmember Rosario Rodriguez **
Folsom,Councilmember YK Chalamcherla **
Fontana,Councilmember Peter Garcia *
Fontana,Councilmember John Roberts
Fontana,Councilmember John Roberts **
Fountain Valley,Councilmember Ted Bui
Fountain Valley,Councilmember Steve Nagel **
Fremont,Vice Mayor Desrie Campbell
Fullerton,Councilmember Ahmad Zahra *
Fullerton,Mayor Pro Tem Nicholas Dunlap
Fullerton,Councilmember Jan M. Flory **
Fullerton,Councilmember Jesus Silva **
Fullerton,Mayor Jennifer Fitzgerald **
Fullerton,Councilmember Bruce Whitaker **
Galt,Councilmember Jay Vandenburg **
Galt,Councilmember Rich Lozano **
Gardena,Councilmember Paulette Francis *
Gardena,Mayor Pro Tem Rodney Tanaka *
Gardena,Mayor Tasha Cerda *
Gardena,Councilmember Mark Henderson
Gardena,Councilmember Art Kaskanian **
Gilroy,Councilmember Carol Marques *
Gilroy,Councilmember Dion Bracco *
Gilroy,Councilmember Peter Leroe-Munoz **
Gilroy,Mayor Marie Blankley **
Glendale,Mayor Ardy Kassakhian
Glendora,Councilmember Michael Allawos *
Glendora,Mayor David Fredendall *
Glendora,Mayor Pro Tem Karen Davis *
Glendora,Councilmember Mendell Thompson *
Glendora,Councilmember Gary Boyer **
Grand Terrace,Councilmember Jeff Allen
Grand Terrace,Councilmember Matt Brown
Gridley,Mayor Mike Farr
Gridley,Vice Mayor Bruce Johnson
Grover Beach,Mayor Pro Tem Robert Robert
Guadalupe,Mayor Ariston Julian
Gustine,Councilmember Sherri Marsigli
Gustine,Councilmember Jim Bonta **
Half Moon Bay,Councilmember Paul Nagengast
Half Moon Bay,Mayor Debbie Ruddock
Half Moon Bay,Vice Mayor Deborah Penrose
Half Moon Bay,Councilmember Harvey Rarback **
Hanford,Councilmember Martin Devine **
Hawthorne,Mayor Alex Vargas *
Hawthorne,Councilmember Alex Monteiro
Hawthorne,Councilmember Mike Talleda **
Hawthorne,Councilmember Haidar Awad **
Hawthorne,Councilmember Olivia Valentine **
Hayward,Councilmember Dan Goldstein
Healdsburg,Mayor Chris Herrod
Healdsburg,Councilmember Skylaer Palacios **
Hemet,Mayor Pro Tem Joe Males
Hemet,Mayor Linda Krupa
Hemet,Councilmember Carol Kendrick **
Hermosa Beach,Councilmember Ray Jackson
Hermosa Beach,Councilmember Dean Francois
Hermosa Beach,Councilmember Rob Saemann
Hidden Hills,Councilmember Laura McCorkindale
Hidden Hills,Mayor Pro Tem Joe Loggia
Hidden Hills,Councilmember Eniko Gold
Hidden Hills,Mayor Larry Weber
Hidden Hills,Mayor Bret Katz **
Hidden Hills,Councilmember Stuart Siegel **
Hidden Hills,Councilmember Steve Freedland **
Hillsborough,Councilmember Christine Krolik
Hollister,Councilmember Rolan Resendiz
Hollister,Mayor Ignacio Velazquez **
Huntington Beach,Councilmember Pat Burns
Huntington Beach,Councilmember Barbara Delgleize **
Huntington Beach,Councilmember Erik Peterson **
Huntington Beach,Mayor Kim Carr **
Huntington Beach,Councilmember Mike Posey **
Huntington Beach,Mayor Pro Tem Tito Ortiz **
Huntington Beach,Councilmember Natalie Moser **
Huntington Beach,Councilmember Dan Kalmick **
Imperial Beach,Mayor Mitch McKay
Imperial Beach,Councilmember Carol Seabury
Imperial Beach,Mayor Pro Tem Jack Fisher
Indio,Councilmember Glenn Miller
Industry,Councilmember Newell Ruggles
Industry,Mayor Pro Tem Michael Greubel
Ione,Councilmember Alison LaFayne
Ione,Vice Mayor Stacy Rhoades
Ione,Vice Mayor Diane Wratten **
Irvine,Councilmember Mike Caroll
Isleton,Councilmember Pamela Bulahan
Isleton,Councilmember David Kent **
Jurupa Valley,Councilmember Mike Goodland **
Kerman,Mayor Pro Tem Gary Yep *
Kerman,Councilmember Kevin Nehring **
Kerman,Mayor Pro Tem Bill Nijjer **
Kerman,Councilmember Jennifer Coleman **
Kingsburg,Councilmember Vince Palomar
Kingsburg,Councilmember David Silva
La Canada Flintridge,Councilmember Keith Eich
La Canada Flintridge,Mayor Jeanne Kim Hobson
La Habra,Councilmember Delwin Lampkin *
La Habra,Councilmember Daren Nigsarian
La Habra,Mayor Tom Beamish **
La Habra,Councilmember Steve Simonian **
La Habra Heights,Mayor Brian Bergman *
La Habra Heights,Councilmember Carol Engelhardt *
La Habra Heights,Councilmember John Pespisa *
La Habra Heights,Councilmember Norm Zezula *
La Habra Heights,Councilmember Carey Klingfus **
La Habra Heights,Councilmember Jane Williams **
La Habra Heights,Councilmember Dennis Laherty **
La Quinta,Councilmember Steve Sanchez
Lafayette,Mayor Susan Candell
Lafayette,Councilmember Cameron Burks **
Laguna Beach,Councilmember Peter Blake **
Laguna Hills,Councilmember Dave Wheeler *
Laguna Hills,Councilmember Erica Pezold
Laguna Hills,Councilmember Don Sedgwick **
Laguna Hills,Councilmember Bill Hunt **
Laguna Hills,Councilmember Janine Heft **
Laguna Niguel,Councilmember John Mark Jennings **
Laguna Niguel,Councilmember Elaine Gennawey **
Laguna Niguel,Councilmember Fred Minagar **
Laguna Niguel,Councilmember Sandy Rains **
Laguna Niguel,Mayor Laurie Davies **
Laguna Woods,Councilmember Shari Horne *
Laguna Woods,Councilmember Cynthia Conners *
Laguna Woods,Councilmember Carol Moore *
Laguna Woods,Councilmember Ed Tao **
Laguna Woods,Mayor Noel Hatch **
Lake Elsinore,Councilmember Steve Manos
Lake Forest,Councilmember Benjamin Yu
Lakeport,Councilmember Michael Froio **
Larkspur,Councilmember Sarah Margulies
Lathrop,Councilmember Diane Lazard
Lathrop,Councilmember Minnie Diallo
Lawndale,Mayor Pro Tem Sirley Cuevas *
Lawndale,Councilmember Patrick Kearney
Lawndale,Councilmember Frank Talavera
Lawndale,Mayor Robert Pullen Miles
Lawndale,Councilmember James H Osborne **
Lawndale,Councilmember Dan Reid **
Lawndale,Councilmember Rhonda Hofmann-Gorman **
Lemon Grove,Mayor Pro Tem Jessica Heredia
Lemoore,Councilmember Stuart Lyons
Lemoore,Mayor Patricia Matthews
Lemoore,Mayor Pro Tem Frank Gornick
Lemoore,Councilmember  David Orth **
Lincoln,Mayor Holly Woods-Andreatta
Lincoln,Councilmember Ben Brown
Lindsay,Mayor Pamela Kimball **
Live Oak,Councilmember  Bob Woten
Live Oak,Councilmember  Ashley Hernandez
Live Oak,Councilmember  Lakhvir Ghag  **
Live Oak,Councilmember  J.R. Thiara  **
Livermore,Mayor Bob Woerner **
Livingston,Councilmember Jose Moran **
Livingston,Councilmember Maria Soto **
Lodi,Mayor Ramon Yepez
Lodi,Councilmember Lisa Craig
Lomita,Mayor Mark Waronek *
Lomita,Mayor Pro Tem Barry Waite
Lomita,Councilmember William Uphoff
Lomita,Mayor Cindy Segawa
Lomita,Councilmember James Gazeley
Lomita,"Councilmember Henry Sanchez, Jr **"
Lomita,Councilmember Michael G. Savidan **
Loomis,Mayor Pro Tem Jan Clark-Crets
Los Altos,Mayor Anita Enander **
Los Altos,Councilmember Lynette Lee Eng **
Los Altos Hills,Vice Mayor Linda Swan *
Los Altos Hills,Councilmember Stanley Mok *
Los Altos Hills,Councilmember George Tyson *
Los Altos Hills,Councilmember Kavita Tankha *
Los Altos Hills,Mayor Rajiv Bhateja
Los Angeles,Councilmember Paul Koretz **
Los Banos,Mayor Pro Tem Deborah Lewis
Los Banos,Councilmember Refugio Llamas **
Los Banos,Mayor Tom Faria **
Los Banos,Councilmember Brett Jones **
Madera,Councilmember  Artemio Villegas
Malibu,Councilmember Paul Grisanti **
Manhattan Beach,Councilmember Amy Howorth *
Manhattan Beach,Councilmember David Lesser *
Manhattan Beach,Mayor Joseph Franklin
Manhattan Beach,Mayor Pro Tem Nina Tarnay
Manhattan Beach,Councilmember Nancy Hersman **
Manhattan Beach,Councilmember Hildy Stern **
Manhattan Beach,Councilmember Suzanne Hadley **
Manhattan Beach,Councilmember Steve Napolitano **
Manhattan Beach,Councilmember Richard Montgomery **
Marysville,Councilmember Brad Hudson
Maywood,Councilmember Mayra Aguiluz
Mendota,Mayor Pro Tem Jose Alonso *
Mendota,Councilmember Joseph Riofrio *
Mendota,Mayor Pro Tem Jesus Mendoza **
Mendota,Mayor Rolando Castro **
Mendota,Councilmember Oscar Rosales **
Menifee,Mayor Ricky Estrada
Menifee,Councilmember Ben Diederich
Menifee,Councilmember Lesa Sobek **
Merced,Mayor Pro Tem Bertha Perez **
Mill Valley,Councilmember Jim Wickham **
Milpitas,Councilmember Hon Lien
Mission Viejo,Mayor Wendy Bucknum *
Mission Viejo,Councilmember Bob Ruesch *
Mission Viejo,Councilmember Trish Kelley
Mission Viejo, Ed Sachs **
Mission Viejo,Councilmember Greg Raths **
Modesto,Councilmember  Rosa Escutia-Braaton
Modesto,Councilmember David Wright
Modesto,Councilmember Tony Madrigal **
Monte Sereno,Councilmember Bryan Mekechuk *
Monte Sereno,Vice Mayor Lisa Shannon
Monte Sereno,Councilmember Shawn Leuthold **
Monte Sereno,Councilmember Rowena Turner **
Monte Sereno,Councilmember Liz Lawler **
Monte Sereno,Councilmember Evert Wolsheimer **
Monte Sereno,Vice Mayor Javed Ellahie **
Monterey,Councilmember Jean Rasch
Monterey,Councilmember Ed Smith
Moreno Valley,Councilmember Elena Baca-Santa Cruz
Morgan Hill,Councilmember Yvonne Martinez Beltran *
Morgan Hill,Councilmember Soraida Iwanaga
Morgan Hill,Mayor Mark Turner
Morgan Hill,Mayor Pro Tem John McKay **
Morgan Hill,Mayor Rich Constantine **
Morgan Hill,Councilmember Rene Spring **
Morgan Hill,Councilmember Gino Borgioli **
Morro Bay,Councilmember Bill Luffee
Morro Bay,Councilmember Zara Landrum
Mountain View,Vice Mayor Lisa Matichak **
Murrieta,Mayor Jon Levell
Murrieta,Mayor Pro Tem Ron Holliday
Murrieta,Councilmember Lori Stone
Murrieta,Councilmember Cindy Warren
Murrieta,Councilmember Kelly Seyarto **
Murrieta,Mayor Pro Tem Christi White **
Murrieta,Councilmember Jonathan Ingram **
Murrieta,Mayor Scott Vinton **
Murrieta,Mayor Gene Wunderlich **
Needles,Councilmember Joanne Pogue *
Needles,Mayor Janet Jernigan *
Needles,Councilmember Janet McCorkle *
Needles,Councilmember Jaime McCorkle
Needles,Councilmember Clayton Hazlewood **
Needles,Councilmember Tim Terral **
Needles,Councilmember Shawn Gudmundson **
Nevada City,Mayor Daniela Fernandez *
Newark,Mayor Michael Hannon
Newark,Councilmember Maria “Sucy” Collazo **
Newman,Mayor Casey Graham *
Newman,Councilmember Scott Ball *
Newman,Councilmember John Pimentel **
Newman,Councilmember Laroy McDonald **
Newman,Mayor Pro Tem Nick Candea **
Newport Beach,Councilmember Erik Weigand
Newport Beach,Councilmember Robyn Grant
Newport Beach,Councilmember Noah Blom
Newport Beach,Mayor Pro Tem Lauren Kleiman
Newport Beach,Councilmember Diane Dixon **
Newport Beach,Councilmember Duffy Duffield **
Newport Beach,Councilmember Brad Avery **
Newport Beach,Councilmember Will O'Neill **
Newport Beach,Councilmember Joy Brenner **
Norco,Councilmember Kevin Bash
Norwalk,Vice Mayor Margarita Rios
Oakdale,Councilmember Bob Amaral **
Oakley,Councilmember Anissa Williams *
Oakley,Vice Mayor Aaron Meadows *
Oakley,Councilmember Shannon Shaw
Oakley,Councilmember Sue Higgins **
Oakley,Mayor Randy Pope **
Oceanside,Councilmember Peter Weiss
Oceanside,Mayor Esther Sanchez
Ojai,Councilmember Andrew Whitman
Ojai,Mayor Betsy Stix **
Ontario,Councilmember Debra Porada
Ontario,Mayor Pro Tem Alan Wapner
Orange,Councilmember Ana Gutierrez *
Orange,Councilmember Arianna Barrios
Orange,Councilmember Jon Dumitru
Orange,Councilmember John Gyllenhammer
Orange,Councilmember Mike Alvarez **
Orange,Councilmember Chip Monaco **
Orange,Mayor Pro Tem Kim Nichols **
Orange,Mayor Mark Murphy **
Orinda,Mayor Brandyn Iverson
Pacific Grove,Mayor Pro Tem Joe Amelio
Pacific Grove,Councilmember Debby Beck **
Palo Alto,Vice Mayor Greer Stone *
Palo Alto,Councilmember Patrick Burt *
Palo Alto,Councilmember Eric Filseth **
Palo Alto,Councilmember Tom DuBois **
Palo Alto,Councilmember Greg Tanaka **
Palo Alto,Councilmember Lydia Kou **
Palos Verdes Estates,Councilmember Victoria Lozzi *
Palos Verdes Estates,Councilmember Craig Quinn
Palos Verdes Estates,Mayor Michael Kemps
Palos Verdes Estates,Councilmember David McGowan
Palos Verdes Estates,Councilmember Sanford Davidson **
Palos Verdes Estates,Councilmember Kenneth Kao **
Palos Verdes Estates,Mayor Dawn Murdock **
Palos Verdes Estates,Councilmember Jim Roos **
Parlier,Mayor Alma Beltran
Parlier,Councilmember Noe Rodriguez **
Parlier,Councilmember Diane Maldonado **
Parlier,Mayor Pro Tem Trinidad Pimentel **
Paso Robles,Councilmember Chris Bausch
Paso Robles,Mayor John Hamon
Patterson,Councilmember Dominic Farinha **
Petaluma,Councilmember Dennis Pocekay **
Pinole,Councilmember Maureen Toms
Pismo Beach,Mayor Pro Tem Mary Ann Reiss
Pismo Beach,Councilmember Scott Newton
Placentia,Councilmember Ward Smith
Placentia,Councilmember Kevin Kirwin
Pleasanton,Councilmember Julie Testa
Pleasanton,Councilmember Jeff Nibert
Pleasanton,Councilmember Valerie Arkin **
Pleasanton,Councilmember Karla Brown **
Plymouth,Vice Mayor Holger Hornisch
Plymouth,Vice Mayor Michael McLaughlin **
Point Arena,Councilmember Anna Dobbins
Point Arena,Councilmember Eric Dahlhoff **
Pomona,Councilmember Steve Lustro
Port Hueneme,Councilmember Steven Gama
Port Hueneme,Councilmember Bobby Martinez **
Porterville,Councilmember Stan Green
Poway,Deputy Mayor  Jenny Maeda
Poway,Mayor Steve Vaus
Rancho Cordova,Councilmember David Sander
Rancho Mirage,Councilmember Steve Downs
Rancho Palos Verdes,Councilmember Barbara Ferraro *
Rancho Palos Verdes,Mayor David Bradley *
Rancho Palos Verdes,Mayor Pro Tem Paul Seo
Rancho Palos Verdes,Councilmember Stephen Perestam
Rancho Palos Verdes,Councilmember George Lewis
Rancho Palos Verdes,Councilmember Ken Dyda **
Rancho Palos Verdes,Mayor Pro Tem Eric Alegria **
Rancho Palos Verdes,Mayor John Cruikshank **
Rancho Santa Margarita,Mayor Pro Tem Anne Figueroa *
Rancho Santa Margarita,Mayor L. Anthony Beall *
Rancho Santa Margarita, Brad McGirr *
Rancho Santa Margarita,Councilmember Keri Lynn Baert
Rancho Santa Margarita,Mayor Carol  Gamble **
Red Bluff,Councilmember Pat Hurton
Redondo Beach,Councilmember Chadwick Castle
Redondo Beach,Councilmember Brad Waller
Redondo Beach,Councilmember Christian Horvath **
Redondo Beach,Councilmember Laura Emdee **
Redondo Beach,Councilmember John Gran **
Redondo Beach,Mayor Bill Brand **
Redondo Beach,Councilmember Nils Nehrenheim **
Redondo Beach,Mayor Pro Tem Todd Loewenstein **
Redwood City,Councilmember Chris Struken
Reedley,Mayor Pro Tem Mary Fast *
Reedley,Mayor Matthew Tuttle
Reedley,Councilmember Frank Piñon **
Reedley,Mayor Pro Tem Robert Beck **
Reedley,Councilmember Ray Soleno **
Reedley,Councilmember Suzanne Byers **
Reedley,Councilmember Anita Betancourt **
Rialto,Mayor Pro Tem Ed Scott
Ridgecrest,Mayor Pro Tem Solomon Rajaratnam *
Ridgecrest,Councilmember Kyle Blades *
Ridgecrest,Councilmember Scott Hayman *
Ridgecrest,"Councilmember John ""Skip"" Gorman"
Ridgecrest,Councilmember Peggy Breeden  **
Ridgecrest,Mayor Eric Bruen **
Rio Vista,Vice Mayor Rick Dolk *
Rio Vista,Councilmember Walt Stanish *
Rio Vista,Mayor Edwin Okamura
Rio Vista,Councilmember Ronald Kott **
Rio Vista,Councilmember David Hampton **
Rio Vista,Councilmember Debra J King **
Riverside,Councilmember Jim Perry **
Rocklin,Mayor David Bass
Rocklin,Vice Mayor Bill Halldin
Rocklin,Councilmember Greg Janda
Rocklin,Councilmember Ken Broadway
Rohnert Park,Councilmember Susan Hollingworth Adams
Rohnert Park,Mayor Joseph Callinan **
Rohnert Park,Councilmember Pam Stafford **
Rolling Hills,Mayor Bea Dieringer *
Rolling Hills,Councilmember Jeff Pieper *
Rolling Hills,Councilmember Leah Mirsch *
Rolling Hills,Mayor Pro Tem James Black *
Rolling Hills,Councilmember Patrick Wilson *
Rolling Hills Estates,Councilmember Velveth Schmitz *
Rolling Hills Estates,Mayor Frank Zerunyam *
Rolling Hills Estates,Councilmember Britt Huff *
Rolling Hills Estates,Councilmember Debby Stegura
Rolling Hills Estates,Mayor Pro Tem Pam Brown Schachter
Rolling Hills Estates,Councilmember Judy Mitchell **
Rolling Hills Estates,Councilmember Steven Zuckerman **
Rosemead,Councilmember Margaret Clark
Roseville,Councilmember Pauline Roccucci *
Roseville,Councilmember Bruce Houdesheldt *
Roseville,Mayor Krista Bernasconi *
Roseville,Mayor John AllardI II **
Roseville,Councilmember Scott Alvord **
San Anselmo,Councilmember Eileen Burke
San Anselmo,Councilmember Brian Colbert **
San Clemente,Councilmember Victor Cabral
San Dimas,Mayor Emmett Badar *
San Dimas,Mayor Pro Tem Eric Weber *
San Dimas,Councilmember Eric Nakano *
San Dimas,Councilmember Ryan Vienna
San Dimas,Councilmember Denis Bertone **
San Dimas,Mayor Pro Tem John Ebiner **
San Fernando,Councilmember Mary Mendoza *
San Fernando,Mayor Joel Fajardo **
San Fernando,Councilmember Robert C. Gonzales **
San Fernando,Councilmember Sylvia Ballin **
San Fernando,Councilmember Hector Pacheco **
San Gabriel,Councilmember John Wu
San Jacinto,Mayor Crystal Ruiz
San Jacinto,Councilmember Valerie Vandever
San Jacinto,Councilmember Brian Hawkins **
San Juan Bautista,Councilmember Jackie Morris-Lopez
San Juan Capistrano,Mayor John Campbell
San Juan Capistrano,Councilmember Howard Hart
San Marcos,Mayor Rebecca Jones
San Marcos,Councilmember Ed Musgrove
San Marino,Mayor Tony Chou
San Marino,Vice Mayor Calvin Lo
San Marino,Councilmember Gretchen Shepherd Romey
San Marino,Councilmember Ken Ude **
San Marino,Mayor Susan Jakubowski **
San Marino,Councilmember Steven Huang **
San Marino,Councilmember Steve Talt **
San Rafael,Vice Mayor Rachel Kertz
San Ramon,Vice Mayor Scott Perkins **
Sanger,Mayor Eli Ontiveros **
Santa Ana,Councilmember Nelida Mendoza **
Santa Barbara,Mayor Randy Rowse
Santa Barbara,Councilmember Kristen Sneddon
Santa Clarita,Councilmember Jason Gibbs *
Santa Clarita,Councilmember Bill Miranda *
Santa Clarita,Mayor Laurene Weste *
Santa Clarita,Councilmember Marsha McLean *
Santa Clarita,Councilmember Cameron Smyth **
Santa Cruz,Councilmember Renee Golder
Santa Cruz,Councilmember Katherine Beiers **
Santa Cruz,Councilmember Sandy Brown **
Santa Maria,Councilmember Gloria Flores
Santa Maria,Councilmember Etta Waterfield **
Santa Monica,Councilmember Christine Parra **
Santa Monica,Councilmember Phil Brock **
Santee,Councilmember Rob McNelis *
Santee,Councilmember Ronn Hall *
Santee,Vice Mayor Dustin Trotter *
Santee,Mayor John Minto
Santee,Councilmember Laura Koval
Saratoga,Councilmember Kookie Fitzsimmons *
Saratoga,Vice Mayor Tina Walia *
Saratoga,Mayor Chuck Page
Saratoga,Councilmember Yan Zhao
Saratoga,Councilmember Rishi Kumar **
Saratoga,Councilmember Mary-Lynne Bernald **
Seal Beach,Councilmember Joe Kalmick
Seal Beach,Councilmember Nathan Steele
Seal Beach,Councilmember Thomas Moore **
Seaside,Councilmember Alex Miller
Seaside,Councilmember Alexis Garcia-Arrazola
Sebastopol,Councilmember Phil Carter
Selma,Mayor Pro Tem Beverly Cho **
Simi Valley,Mayor Pro Tem Elaine Litster
Simi Valley,Councilmember Mike Judge
Simi Valley,Councilmember Rocky Rhodes
Simi Valley,Mayor Fred D. Thomas **
Solana Beach,Councilmember David Zito
Solana Beach,Mayor Lesa Heebner
Solana Beach,Deputy Mayor Jill MacDonald
Solana Beach,Councilmember Kristi Becker
Solvang,Councilmember Claudia Orona *
Solvang,Councilmember Mark Infanti
Solvang,Mayor Charlie Uhrig **
Solvang,Councilmember Jim Thomas **
Solvang,Councilmember Robert Clarke **
Sonoma,Councilmember John Gurney
Sonora,Mayor Pro Tem Suzanne Cruz **
South Pasadena,Mayor Sheila Rossi
South Pasadena,Councilmember Jon Primuth
South Pasadena,Councilmember Michael Cacciotti
South Pasadena,Councilmember  Diana Mahmud **
South Pasadena,Mayor Evelyn Zneimer **
Stanton,Councilmember Victor Barrios
Stanton,Mayor Pro Tem Gary Taylor
Suisun City,Mayor Alma Hernandez
Sunnyvale,Councilmember Michael S. Goldman **
Sutter Creek,Councilmember Jim Swift
Temecula,Mayor Jessica Alexander
Temple City,Councilmember Cynthia Sternquist
Thousand Oaks,Councilmember Claudia Bill-de la Pena **
Torrance,Councilmember Jeremy Gerson
Torrance,Councilmember Bridgett Lewis
Torrance,Councilmember Betty Lieu
Torrance,Mayor Sharon Kalani
Torrance,Councilmember David Kartsonis
Torrance,Councilmember Asam Sheikh
Torrance,Mayor Patrick Furey **
Torrance,Councilmember Tim Goodrich **
Torrance,Councilmember Heidi Ann Ashcraft **
Torrance,Councilmember Jack Walser **
Torrance,Councilmember Mike Griffiths **
Torrance,Councilmember Aurelio Mattucci **
Torrance,Mayor George Chen **
Torrance,Mayor Pro Tem Jon Kaji **
Tracy,Mayor Pro Tem Eleassia Davis **
Trinidad,Councilmember Jack Tuttle
Tustin,Mayor Austin Lumbard
Union City,Vice Mayor Jaime Patino
Union City,Councilmember Jeff Wang
Upland,Councilmember Rudy Zuniga
Vacaville,Councilmember Sarah Chapman
Vallejo,Mayor Pro Tem Hermie R. Sunga **
Vallejo,Councilmember Cristina Arriola **
Ventura,Councilmember Liz Campos
Ventura,Councilmember Christy Weir **
Victorville,Mayor Pro Tem Bob Harriman
Villa Park,Councilmember Kelly McBride
Villa Park,Councilmember Crystal Miles
Villa Park,Councilmember Chad Zimmerman **
Villa Park,Councilmember Robert Collacot **
Villa Park,Councilmember Robbie Pitts **
Villa Park,Mayor  Vince Rossini **
Visalia,Vice Mayor Liz Wynn
Vista,Councilmember Jeff Fox
Vista,Mayor John Franklin
Walnut,Councilmember Nancy Tragarz
Walnut,Councilmember Dr. Allen Wu
West Covina,Mayor Letty Lopez-Viado *
West Covina,Councilmember Tony Wu *
West Covina,Councilmember Jessica C. Shewmaker **
West Covina,Councilmember Lloyd A. Johnson **
West Covina,Mayor Dario Castellanos **
Westlake Village,Councilmember Ned Davis
Westminster,Councilmember NamQuan Nguyen
Westminster,Councilmember CARLOS MANZO
Westmorland,Councilmember Anna Beltran
Westmorland,Mayor Justina Cruz
Whittier,Mayor Pro Tem Cathy Warner *
Whittier,Councilmember Jessica Martinez **
Whittier,Mayor Joe Vinatieri **
Whittier,Councilmember Octavio Cesar Martinez **
Whittier,Councilmember Fernando Dutra **
Wildomar,Councilmember Joseph Morabito
Woodside,Councilmember Brian Dombkowski *
Woodside,Councilmember Chris Shaw *
Woodside,Councilmember Dick Brown
Woodside,Councilmember John Carvell **
Yorba Linda,Mayor Pro Tem Peggy Huang *
Yorba Linda,Mayor Carlos Rodriguez *
Yorba Linda,Councilmember Tara Campbell *
Yorba Linda,Councilmember Janice Lim
Yorba Linda,Councilmember Peggy Huang **
Yorba Linda,Mayor Gene Hernandez **
Yorba Linda,Mayor Pro Tem Beth Haney **
Yountville,Councilmember Robin McKee-Cant
Yucaipa, Jon Thorp *
Yucaipa,Mayor Chris Vanable
Yucaipa,Councilmember Judy Woolsey
Yucaipa,Mayor Pro Tem Justin Beaver
Yucaipa,Councilmember David Avila **
Yucaipa,Councilmember Greg Bogh **
Yucaipa,Councilmember Bobby Duncan **
Yucca Valley,Mayor  Merl Abel *
Yucca Valley,Councilmember Rick Denison *
Yucca Valley,Councilmember Jeff Drozd *
Yucca Valley,Councilmember Robert Lombardo *
Yucca Valley,Councilmember Robert Lombardo *
`
